import React, { useContext, useEffect } from "react";
import PageNotFound from "../404";
import { UserDetailProvider } from "@/contexts/UserDetailContext";
import axios from "axios";
import BlogDetails from "@/components/Blogs/BlogDetails";
import { Mixpanel } from "@/elements/Mixpanel";
import moment from "moment";

export default function BlogsPage({ data, relatedData, show }) {
    const userDetail = useContext(UserDetailProvider);
    useEffect(() => {
        userDetail.setBtn({
            show: true,
            beforeLogin: "Activate trial",
            afterLogin: "Download the app now",
            isProPage: true,
            page: "blog"
        });
        Mixpanel.pageView({
            page: "blog",
            title: data?.slug
        });
    }, []);

    if (data) {
        if (show) {
            return <BlogDetails item={data} relatedData={relatedData} />;
        } else {
            return <PageNotFound />;
        }
    } else {
        return <PageNotFound />;
    }
}

export async function getStaticProps(ctx) {
    const { params } = ctx;
    const { name } = params;

    const requests = [
        axios.get(`${process.env.apiBaseURL}/resources/web/footer-sections`).catch(() => ({ data: null })),
        axios
            .get(`https://univest.in/blogs-2/wp-json/wp/v2/posts?_embed=author,wp:term&slug=${name}`)
            .catch((err) => {})
    ];

    const [footerContentRes, blogRes] = await Promise.all(requests);

    const category = blogRes.data?.[0]?.categories ?? [];
    const data = blogRes.data?.[0] ?? null;
    const categoryRes = await axios
        .get(`https://univest.in/blogs-2/wp-json/wp/v2/posts?per_page=6&category=${category}`)
        .catch((err) => {});

    return {
        props: {
            footerContentData: footerContentRes?.data ?? null,
            data,
            relatedData: categoryRes?.data ?? [],
            show: !(moment(data?.date).isBefore(moment("2024-11-30")) && data?.slug?.includes("weekly-update-"))
        },
        revalidate: 60
    };
}
export async function getStaticPaths() {
    return {
        paths: [{ slug: "weekly-update-57" }].map((ele) => ({
            params: {
                name: ele.slug
            }
        })),
        fallback: true
    };
}
